import { createEnum } from './enum.js'

export default createEnum('Right lower lid', 'Left lower lid', 'Both lower lids');
